"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const master_1 = require("../../constants/master");
class OptimizedMixPanel {
    constructor(mixpanel) {
        this.mixpanel = mixpanel;
    }
    track(event_name, properties, optionsOrCallback, callback) {
        const config = (0, master_1.getMasterConfig)();
        const subDomain = config.subDomain;
        // Add the subDomain field to the properties
        if (properties === undefined) {
            properties = { subDomain: subDomain };
        }
        else {
            properties.subDomain = subDomain;
        }
        // Call the original track function
        this.mixpanel.track(event_name, properties, optionsOrCallback, callback);
    }
}
exports.default = OptimizedMixPanel;
